import Vue from "vue";
import VueRouter from "vue-router";
//import Home from "../views/Home.vue";

import login from '@/views/Login'
import main from '@/views/Main'
import mensaje from '@/views/Mensaje'

import config from "@/components/_config/conf";

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/mensaje',
    name: 'mensaje',
    component: mensaje
  },
  {
    path: '/main',
    name: 'main',
    component: main,
    meta: {
      autentificado: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

function validarLocalSession() {
  let local = window.localStorage.getItem('EPA_AUTH');
  if (local != null) {
    try {
      var localJson = JSON.parse(local)
      var token = localJson.token
      return token
    } catch (err) {
      console.log('catch', err)
      window.localStorage.removeItem('EPA_AUTH');
      return 'localSession invalida'
    }
  }
  return 'localSession invalida'
}
router.beforeEach((to, from, next) => {

  let autorization = to.matched.some(record => record.meta.autentificado);

  if (autorization) {

    var token = validarLocalSession();

    if (token != 'localSession invalida') {

      let param = "token=" + token;
      let resultado = config.enviar("get", "validarToken", param);

      resultado.then((result) => {

        if (result.data.msj != "ok") {
          window.localStorage.removeItem('EPA_AUTH')

          next('login')
        } else {
          next()
        }
      }).catch((error) => {
        window.localStorage.removeItem('EPA_AUTH');
        console.log('catched', error)
        next('mensaje')
      }).finally(() => {

      });
    }
    else {
      next('login')
    }
  } else {
    if (validarLocalSession() != 'localSession invalida')
      next('main')
    else
      next()
  }
})

export default router;
